export default [
  '$uibModalInstance',
  'config',
  'onApprove',
  'dealRentService',
  function (
    $uibModalInstance,
    config,
    onApprove,
    dealRentService,
  ) {
  this.ofertaUrl = dealRentService.ofertaUrl;
  this.rulesApproved = false;
  this.passportApproved = false;
  this.selfEmployedApproved = false;
  this.bankApproved = false;
  this.cardApproved = false;
  this.showError = false;
  this.showRulesError = false;

  this.isCheckBoxesChecked = () =>
      this.passportApproved &&
      this.selfEmployedApproved &&
      this.bankApproved &&
      this.cardApproved;

  this.onApprove = () => {
    this.showError = !this.isCheckBoxesChecked();
    this.showRulesError = !this.rulesApproved;
    if (this.showError || this.showRulesError) {
      return;
    }

    dealRentService.addDealVersion();
    onApprove();
    $uibModalInstance.dismiss();
  };
}];
